'use client';

import { useGtmTrack } from '../index';
import { ANALYTICS_EVENTS } from '../types';
import type { TrackingFunction } from '../types';

export const useModuleViewedTracking = (props = {}, autoTrack: boolean = false): TrackingFunction => {
  return useGtmTrack(
    {
      eventName: ANALYTICS_EVENTS.MODULE_VIEWED,
      properties: props,
    },
    autoTrack,
  );
};
